import { useEffect, useId, useRef, useState } from 'react';
import { useI18n } from '../i18n';
import { AppBuildInfoPopover } from './AppBuildInfoPopover';
import styles from './AppBuildInfoTrigger.module.css';

export function AppBuildInfoTrigger() {
  const { t } = useI18n();
  const popoverId = useId();
  const wrapRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      return;
    }
    const onPointerDown = (event: PointerEvent) => {
      if (!wrapRef.current?.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('pointerdown', onPointerDown);
    return () => document.removeEventListener('pointerdown', onPointerDown);
  }, [open]);

  return (
    <div className={styles.wrap} ref={wrapRef}>
      <button
        type="button"
        className={styles.iconBtn}
        aria-label={t('profile.hub.buildInfoAria')}
        aria-expanded={open}
        aria-controls={popoverId}
        onClick={() => setOpen((value) => !value)}
      >
        <BuildInfoIcon />
      </button>
      {open ? <AppBuildInfoPopover id={popoverId} /> : null}
    </div>
  );
}

function BuildInfoIcon() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 10v6" strokeLinecap="round" />
      <circle cx="12" cy="7.25" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  );
}
